import type {Question} from '@cp/model';
import {questionUserFlag} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useFlagQuestionAsError() {
  const {
    fn: flagQuestionAsError,
    loading,
    error,
  } = useFunctionWrap(
    async (moduleId: string, questionId: string, statusNote?: string): Promise<Question> =>
      questionUserFlag({moduleId, questionId, kind: 'error', statusNote}) as Promise<Question>,
  );

  return {
    flagQuestionAsError,
    loading,
    error,
  };
}
